import { CheckListDto } from './check-list-dto.model';
import { CheckListProcessType } from '../service-proxies';


export class EmployeeCheckListDto implements IEmployeeCheckListDto {
    id!: number;
    employeeId!: number;
    checkList!: CheckListDto;
    checkListType!: CheckListProcessType;
    checkListTypeName!: string | undefined;
    isSubmitted!: boolean;
    submitDate!: Date | undefined;
    checkListRemark!: string | undefined;

    constructor(data?: IEmployeeCheckListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.checkList = _data["checkList"] ? CheckListDto.fromJS(_data["checkList"]) : <any>undefined;
            this.checkListType = _data["checkListType"];
            this.checkListTypeName = _data["checkListTypeName"];
            this.isSubmitted = _data["isSubmitted"];
            this.submitDate = _data["submitDate"] ? new Date(_data["submitDate"].toString()) : <any>undefined;
            this.checkListRemark = _data["checkListRemark"];
        }
    }

    static fromJS(data: any): EmployeeCheckListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeCheckListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["checkList"] = this.checkList ? this.checkList.toJSON() : <any>undefined;
        data["checkListType"] = this.checkListType;
        data["checkListTypeName"] = this.checkListTypeName;
        data["isSubmitted"] = this.isSubmitted;
        data["submitDate"] = this.submitDate ? this.submitDate.toISOString() : <any>undefined;
        data["checkListRemark"] = this.checkListRemark;
        return data; 
    }
}

export interface IEmployeeCheckListDto {
    id: number;
    employeeId: number;
    checkList: CheckListDto;
    checkListType: CheckListProcessType;
    checkListTypeName: string | undefined;
    isSubmitted: boolean;
    submitDate: Date | undefined;
    checkListRemark: string | undefined;
}

